// src/App.js
import React, { useEffect, useState } from 'react';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { checkAuth, logout } from './api';

export default function App() {
  const [authenticated, setAuthenticated] = useState(null); // null = loading
  const [error, setError] = useState(null);

  // Check auth on first load
  useEffect(() => {
    checkAuth()
      .then((ok) => setAuthenticated(ok))
      .catch(() => setAuthenticated(false));
  }, []);

  const handleLogout = async () => {
    await logout();
    setAuthenticated(false);
  };

  if (authenticated === null) {
    return <div className="p-8 text-center">Loading...</div>;
  }

  if (!authenticated) {
    return <Login onLogin={() => setAuthenticated(true)} error={error} />;
  }

  return (
    <div>
      <header className="flex justify-between items-center p-4 bg-white shadow">
        <span className="font-bold text-lg">Corporate Dashboard</span>
        <button
          onClick={handleLogout}
          className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300"
        >
          Log Out
        </button>
      </header>
      <Dashboard />
    </div>
  );
}
